<template>
  <div>
    <v-skeleton-loader
      type="table"
      v-show="$apollo.queries.person.loading"
    />
    <v-simple-table
      v-show="!$apollo.queries.person.loading"
      dense
      v-if="person.identity && person.identity.account"
    >
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Login</th>
            <th class="text-left">Access type</th>
            <th class="text-left">Account email</th>
            <th class="text-right">Account ID</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-left pl-5">{{ person.identity.account.preferredUsername }}</td>
            <td class="text-left pl-5">{{ person.identity.account.accessType }}</td>
            <td class="text-left pl-5">{{ person.identity.account.email }}</td>
            <td class="text-left pl-5">{{ person.identity.subject }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-btn
      text
      color="primary"
      @click="register"
      :loading="registering"
      :disabled="$apollo.queries.person.loading || registering"
    >
      Create myMSA login
    </v-btn>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'PersonIdentity',

  props: {
    personId: {
      type: String,
      required: true
    }
  },

  data: () => ({
    person: {},
    registering: false
  }),

  apollo: {
    person: {
      query: gql`query GetPerson($id: MongoID!) {
        person: personById(_id: $id) {
          _id
          name
          email
          identity {
            _id
            issuer
            subject
            account {
              sub
              accessType
              preferredUsername
              email
            }
          }
        }
      }`,
      variables () {
        return {
          id: this.personId
        }
      },
      error (e) {
        this.onError(e)
      }
    }
  },

  methods: {
    onError (e) {
      this.$emit('error', e)
    },

    async register () {
      this.registering = true

      try {
        await this.$apollo.mutate({
          mutation: gql`mutation ($personId: MongoID!) {
            personCreateIdentity(personId: $personId) {
              _id
              updatedAt
              identity {
                _id
                issuer
                subject
                account {
                  sub
                  accessType
                  preferredUsername
                  email
                }
              }
            }
          }`,
          variables: {
            personId: this.personId
          }
        })
      } catch (e) {
        this.onError(e)
        return
      } finally {
        this.registering = false
      }
    }
  }
}
</script>
